
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.336 40.502c-3.7 2.6-8.3 3-12.9 2.9 4.4-2.1 5.3-7.1 5.4-12.1.1-.4.1-.8 0-1.1v-4.2c0-.4-.1-1.6-.7-1.6h-24.3c-.6 0-.7 1.2-.7 1.6h-6.1c-.6 0-.7 1.2-.7 1.6 0 2.2-.4 5 .4 7.1 1.2 3 4.2 2.6 6.9 2.6.4.9.8 1.8 1.3 2.6 1.1 1.7 2.5 2.8 4 3.5-4.7.1-9.4-.3-13.1-2.9-.8-.5-1.2 2.5-.4 3 3.9 2.8 8.9 3.1 13.8 3 .1.6.3 1 .7 1h12.3c.4 0 .6-.4.7-1 4.9.1 9.9-.2 13.8-3 .8-.5.4-3.5-.4-3zm-38.4-8c-.2-.7 0-1.8 0-2.5v-.9h5.3c-.1 1.7-.1 3.4 0 5-1.8.1-4.8.3-5.3-1.6zm8.6 5.9c-1.1-1.3-1.6-2.9-1.8-4.7v-1.6h12.3c1 0 1-3.2 0-3.2h-12.3v-1.5h22.9v1.5h-4.4c-1 0-1 3.2 0 3.2h4.2c-.4 4.6-1.9 8.6-8.1 9.1-4.4.1-9.6.9-12.8-2.8zM28.336 19.002c.4.8.5.8-.2 1.6-.4.6-.4 1.5-.2 2.2.1.4.5 1.1.9.6.9-1.2 1.4-2.7 1.3-4.3-.1-.7-.2-1.3-.5-1.8-.2-.5-.8-1-.5-1.4.6-.7.1-3.7-.7-2.7-.9 1.1-1 2.7-.8 4 .2.6.4 1.2.7 1.8zM33.636 19.002v-.1c.1 0 .1 0 0 .1z"}}),_c('path',{attrs:{"d":"M32.536 20.902v.1c-.4.6-.4 1.5-.2 2.1.1.4.5 1.2.9.6.6-.9.9-1.9.8-2.9 0-.5-.1-1-.3-1.5 0-.1-.1-.2-.2-.3 0 .1-.1.2-.2.4.1-.1.1-.3.2-.4 0 0 0-.1-.1-.1-.2-.3.2-.4.1 0 .2-.5.1-1.1 0-1.6-.1-.4-.5-1.1-.9-.6-.6.8-.7 2-.6 3 .2.4.4.8.5 1.2zm.2.5c.1.1.1.1 0 0 0 .1.1.1 0 0z"}})])
          )
        }
      }
    